import moment from 'moment';

export const parseDate = (date, format) => {
  if (typeof date !== 'string') {
    return date.isValid();
  }

  const parsed = moment(date, format);

  // if date is not valid or the formatted output after parsing does not match
  // the string value passed in (avoids overflows)
  if (!parsed.isValid() || parsed.format(format) !== date) {
    return null;
  }

  return parsed;
};
